// Feature-detected shims, loaded only where the browser lacks the API.
export const installPolyfills = async () => {
	const jobs : Promise<unknown>[] = []
	if (!('URLPattern' in globalThis)) jobs.push(import('urlpattern-polyfill'))
	if (!('navigation' in globalThis)) jobs.push(import('@virtualstate/navigation/polyfill'))
	await Promise.all(jobs)
}
